import React from 'react';
import { ThemeProvider } from './ui/theme-provider';
import { ExperienceTimeline } from './ExperienceTimeline';

const Experience: React.FC = () => {
  return (
    <ThemeProvider>
      <section id="experience" className="min-h-screen pt-24 pb-8 sm:pt-28 sm:pb-12 md:py-16 lg:py-20 relative z-20 scroll-mt-16" style={{backgroundColor: '#222222'}}>
        {/* Professional Timeline */}
        <div>
          <ExperienceTimeline />
        </div>
      </section>
    </ThemeProvider>
  );
};

export default Experience;